// extracted by mini-css-extract-plugin
export default {"wrapper":"providerReviews_wrapper__-wELX","title":"providerReviews_title__Fklyh"};